<template>
  <div id="app">
    <Guide v-if="isShowGuide"></Guide>
    <DownLoad :platform="platform"></DownLoad>
  </div>
</template>

<script>
import DownLoad from '../components/Downloadnew.vue';
import Guide from '../components/Guide.vue';
import { isRunInWeChat, isRunInQQ, isRunInDingTalk } from '../utils/env';

export default {
  name: 'App',
  props: {
    platform: String,
  },
  components: {
    Guide,
    DownLoad,
  },
  // data() {
  //   return {
  //     isShowGuide: isRunInWeChat() || isRunInQQ() || isRunInDingTalk()
  //   }
  // },
  computed: {
    isIos() {
      return this.platform === 'ios';
    },
    isShowGuide() {
      // return isRunInDingTalk();
      return isRunInWeChat() || isRunInQQ() || isRunInDingTalk();
    },
  },
};
</script>
